import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 6rem auto 4rem;
  padding: 2rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(122, 73, 136, 0.1);
`;

const Title = styled.h1`
  color: #7A4988;
  font-size: 2.4rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Subtitle = styled.h2`
  color: #7A4988;
  font-size: 1.6rem;
  margin-bottom: 1rem;
`;

const Text = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

function Returns() {
  return (
    <PageContainer>
      <Title>Return Policy</Title>
      
      <Section>
        <Subtitle>Eligibility</Subtitle>
        <Text>
          We accept returns within 14 days of delivery for unused items in their original 
          condition with tags attached. Custom orders are non-returnable unless damaged 
          or defective.
        </Text>
      </Section>

      <Section>
        <Subtitle>How to Return</Subtitle>
        <Text>
          To initiate a return, email us at <a href="mailto:lavenderandpalmco@gmail.com">lavenderandpalmco@gmail.com</a>  with your order 
          number and reason for return. We’ll provide a return shipping label. Items must 
          be shipped back within 7 days of receiving the label.
        </Text>
      </Section>

      <Section>
        <Subtitle>Refunds</Subtitle>
        <Text>
          Once your return is received and inspected (usually within 3-5 business days), 
          we’ll notify you by email about the approval of your refund. Refunds will be 
          processed to your original payment method within 5-10 business days.
        </Text>
      </Section>

      <Section>
        <Subtitle>Damaged or Defective Items</Subtitle>
        <Text>
          If you receive a damaged or defective item, please contact us within 48 hours of 
          delivery with photos of the issue. We’ll arrange a replacement or refund at no 
          additional cost.
        </Text>
      </Section>
    </PageContainer>
  );
}

export default Returns;